export default "__VITE_ASSET__B6ddd4uT__"